import {
    FiZap,
    FiGrid,
    FiBriefcase,
    FiHome,
    FiFolder,
    FiLinkedin,
    FiGithub
} from "react-icons/fi";
import ReactGa4 from "react-ga4";

export const NavBar = () => {
    const handleClick = (platform) => {
        ReactGa4.event({
            category: "Social Links",
            action: "Click",
            label: platform
        })
    }

    return (
        <nav className="w-full flex justify-center mt-6 px-4">
            <div className="bg-gray-900 text-white rounded-full py-3 px-6 flex items-center space-x-6 shadow-lg">
                <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center">
                        <FiGrid className="w-5 h-5" />
                    </div>
                    <span className="font-semibold text-sm hidden md:block">Rahul Prabhu</span>
                </div>

                <div className="w-px h-6"></div>

                <div className="flex items-center space-x-6">
                    <a href="#home" aria-label="Home"><FiHome className="w-5 h-5" /></a>
                    <a href="#projects" aria-label="My Projects"><FiFolder className="w-5 h-5" /></a>
                    <a href="#work" aria-label="My Experience"><FiBriefcase className="w-5 h-5" /></a>
                    <a onClick={() => handleClick('linkedin')} href="https://www.linkedin.com/in/rahul-p-prabhu/" target="_blank" rel="noreferrer" aria-label="LinkedIn Profile"><FiLinkedin className="w-5 h-5" /></a>
                    <a onClick={() => handleClick('github')} href="https://github.com/RahulPPrabhu" target="_blank" rel="noreferrer" aria-label="Github Profile"><FiGithub className="w-5 h-5" /></a>
                    <a href="#contact" aria-label="Mail Me"><FiZap className="w-5 h-5" /></a>
                </div>
            </div>
        </nav>
    );
};
